import React, { useState } from 'react';
import Logo from '../../images/logo-2.svg';
import { Link } from 'react-router-dom';
import MobileMenu from '../../components/MobileMenu';
import LanguageSwitcher from '../header/LanguageSwitcher';
import { queryClient, useFetch } from '../../hooks/useFetch';
import { useTranslation } from 'react-i18next';
import { fetchContact } from '../../api/api';
import axios from 'axios';

const Header2 = ({ hclass }) => {
    const [isSidebarShow, setSidebarShow] = useState(false);
    const { t } = useTranslation(); // Use the translation hook
    const projects = queryClient.getQueryData(['projects']);
    const { data: contact } = useFetch(["contact"], fetchContact);

    const sidebarHandler = () => {
        setSidebarShow(!isSidebarShow);
    };

    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMessage('');

        try {
            // Send form data to Formspree
            await axios.post('https://formspree.io/f/mjkvejnb', { email });
            setMessage(t('successMessage'));
            setEmail(''); // Reset email field on success
        } catch (error) {
            setMessage(t('errorMessage'));
            console.error('Newsletter submission error:', error);
        } finally {
            setSubmitting(false);
        }
    };
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <header id="header">
            <div className={`wpo-site-header ${hclass}`}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        <img src={Logo} alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/home">{t('menu.home')}</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about">{t('menu.about')}</Link></li>
                                        <li className="menu-item-has-children">
                                            <Link to="/service">{t('menu.service')}</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/project">{t('menu.project')}</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/blog">{t('menu.blog')}</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/contact">{t('menu.contact')}</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-1 col-2">
                                <div className="header-right">
                                    <div className="header-search-form-wrapper text-white">
                                        <LanguageSwitcher />
                                        <a href="https://Portal.alriyada.om" className="theme-btn login" target="_blank" rel="noopener noreferrer">
                                             {t("login")}
                                        </a>
                                    </div>
                                    <div className="header-right-menu-wrapper">
                                        <div className="header-right-menu">
                                            <div className="right-menu-toggle-btn" onClick={sidebarHandler}>
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                            <div className={`header-right-menu-wrap ${isSidebarShow ? 'right-menu-active' : ''}`}>
                                                <button onClick={sidebarHandler} className="right-menu-close">
                                                    <i className="ti-close"></i>
                                                </button>
                                                <div className="logo"><img src={Logo} alt="" /></div>
                                                <div className="header-right-sec">
                                                    <div className="project-widget widget">
                                                        <h3>{t('latestProjects.title')}</h3>
                                                        <ul>
                                                            {projects?.data?.data.slice(0, 6).map((project, index) => (
                                                                <li key={index}>
                                                                    <Link onClick={ClickHandler} to={`/project-single/${project.id}`}>
                                                                        <img src={`${process.env.REACT_APP_API_URL}/api/images/${project?.data?.thumbnail}`} alt="" />
                                                                    </Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    <div className="widget wpo-contact-widget">
                                                        <div className="widget-title">
                                                            <h3>{t('contact.title')}</h3>
                                                        </div>
                                                        <div className="contact-ft">
                                                            <ul>
                                                                <li><i className="fi flaticon-location"></i>{contact?.data?.contact?.firstAddress}</li>
                                                                <li><i className="fi flaticon-telephone"></i>{contact?.data?.contact?.firstPhoneNumber}</li>
                                                                <li><i className="fi flaticon-email"></i>{contact?.data?.contact?.firstEmail}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="widget newsletter-widget">
                                                        <div className="widget-title">
                                                            <h3>{t('newsletter.title')}</h3>
                                                        </div>
                                                        <form onSubmit={handleNewsletterSubmit}>
                                                            <div className="input-1">
                                                                <input
                                                                    type="email"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    className="form-control"
                                                                    placeholder={t('newsletter.placeholder')}
                                                                    required
                                                                    aria-label={t('serviceSidebar.emailPlaceholder')}
                                                                />
                                                                <div className="submit clearfix">
                                                                    <button type="submit"><i className="ti-email"></i></button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header2;
